<template>
	<div>
		<v-container fluid class="py-0">
			<v-row no-gutters class="mb-6">
				<div style="flex-grow: 1">
					<v-text-field
						v-model="search"
						class="py-0 my-0 mb-2 mr-2"
						append-icon="mdi-magnify"
						label="Search"
						single-line
						hide-details
					/>
				</div>
				<div>
					<v-btn color="primary" @click="addConnector()">
						<v-icon> mdi-plus</v-icon>
						Add
					</v-btn>
				</div>
			</v-row>
		</v-container>
		<v-list dense class="pt-0" style="height: 100%">
			<v-list-item-group
				v-model="selectedConnectorIndex"
				style="overflow-y: scroll; height: 100%"
				active-class="primary white--text"
				mandatory
			>
				<v-list-item v-for="(item, i) in filteredItems" :key="i">
					<v-list-item-title>{{ item.Name }}</v-list-item-title>
					<v-list-item-action @click.stop>
						<v-btn
							fab
							small
							icon
							elevation="1"
							class="action-btn"
							@click.stop="editConnector(item)"
						>
							<v-icon small color="primary">mdi-pencil</v-icon>
						</v-btn>
					</v-list-item-action>
					<v-list-item-action class="ml-1 my-0 mr-0" @click.stop>
						<v-btn
							fab
							small
							icon
							elevation="1"
							class="action-btn"
							@click.stop="deleteConnector(item)"
						>
							<v-icon small color="error">mdi-delete</v-icon>
						</v-btn>
					</v-list-item-action>
				</v-list-item>
			</v-list-item-group>
		</v-list>
		<connector-details-modal
			v-if="editedConnector"
			:showDialog="showDialog"
			:connector="editedConnector"
			@close="onClose"
		/>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import {
	ConnectorsListActions,
	ConnectorHeaderActions,
	ConnectorFiltersActions,
} from '../../../store/actions';
import { ConnectorsListGetters } from '../../../store/getters';
import ConfirmDialog from '@/components/core/dialogs/confirmDialog';
import ConnectorDetailsModal from './ConnectorDetailsModal.vue';
export default {
	name: 'ConnectorsList',
	components: {
		ConnectorDetailsModal,
	},
	data() {
		return {
			search: null,
			showDialog: false,
			selectedConnectorIndex: null,
			editedConnector: null,
		};
	},
	computed: {
		...mapGetters({
			selectedGridView: [ConnectorsListGetters.SELECTED_GRID_VIEW],
			connectors: [ConnectorsListGetters.CONNECTORS],
		}),
		filteredItems() {
			if (!this.search) return this.connectors;
			return this.connectors.filter(
				(x) =>
					x.Name &&
					x.Name.toLowerCase().includes(this.search.toLowerCase())
			);
		},
	},
	watch: {
		selectedConnectorIndex(newVal) {
			let selectedConnector = null;
			if (newVal >= 0) {
				selectedConnector = this.filteredItems[newVal];
			}

			this.$store.dispatch(ConnectorHeaderActions.CLEAR).then(() => {
				this.$store.dispatch(
					ConnectorHeaderActions.LOAD_SELECTED_CONNECTOR,
					selectedConnector
				);
			});

			this.$store.dispatch(ConnectorFiltersActions.CLEAR).then(() => {
				this.$store.dispatch(
					ConnectorFiltersActions.LOAD_SELECTED_CONNECTOR,
					selectedConnector
				);
			});
		},
	},
	mounted() {
		this.$store.dispatch(
			ConnectorsListActions.LOAD_CONNECTORS,
			this.selectedGridView.Id
		);
	},
	destroyed() {
		this.$store.dispatch(ConnectorsListActions.CLEAR);
	},
	methods: {
		addConnector() {
			this.editedConnector = {};
			this.showDialog = true;
		},
		onClose() {
			this.editedConnector = {};
			this.showDialog = false;
		},

		editConnector(item) {
			this.editedConnector = item;
			this.showDialog = true;
		},

		deleteConnector(item) {
			ConfirmDialog({
				message: 'Are you sure you want to delete this connector?',
			}).then((isDelete) => {
				if (isDelete) {
					this.$store.dispatch(
						ConnectorsListActions.DELETE_CONNECTOR,
						item
					);
				}
			});
		},
	},
};
</script>
